import type { DataTableHeader } from '@/types/vuetify';

export function createEntityParamsExpandColumn(headerClass = ''): DataTableHeader {
    return {
        title: '',
        key: 'data-table-expand',
        value: 'data-table-expand',
        align: 'center',
        sortable: false,
        minWidth: 28,
        width: 28,
        cellProps: { class: 'px-0' },
        headerProps: { class: headerClass ? `px-0 ${headerClass}` : 'px-0' },
    };
}

export function createEntityParamsExpandedHeaders(paramTitle: string, valueTitle: string): DataTableHeader[] {
    return [
        {
            title: paramTitle,
            key: 'param',
            sortable: true,
            width: 380,
            minWidth: 380,
        },
        {
            title: valueTitle,
            key: 'value',
            sortable: true,
            width: 480,
            minWidth: 480,
        },
        {
            title: '',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 48,
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}
